export default __webpack_public_path__ + "static/media/facebook.6bdf01d0.svg";